import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import { ArrowsClockwise } from "@phosphor-icons/react/ArrowsClockwise";
import { Lightning } from "@phosphor-icons/react/Lightning";
import { PiggyBank } from "@phosphor-icons/react/PiggyBank";

export function Benefits() {
	return (
		<Box
			sx={{
				bgcolor: "var(--mui-palette-neutral-100)",
				color: "var(--mui-palette-common-white)",
				overflow: "hidden",
				py: "120px",
				position: "relative",
			}}>
			<Box
				sx={{
					alignItems: "center",
					display: "flex",
					height: "100%",
					justifyContent: "center",
					left: 0,
					position: "absolute",
					top: 0,
					width: "100%",
					zIndex: 0,
				}}>
				<Box
					component="img"
					src="/new-mangomap-assets/home-cosmic.svg"
					sx={{ height: "auto", width: "1600px" }}
				/>
			</Box>
			<Stack
				spacing={8}
				sx={{ position: "relative", zIndex: 1 }}>
				<Container maxWidth="md">
					<Stack spacing={2}>
						<Typography
							color="text.primary"
							sx={{ textAlign: "center" }}
							variant="h3">
							Deliver Eco-Innovations Faster, Cheaper, and Smarter
						</Typography>
						<Typography
							color="text.secondary"
							sx={{ textAlign: "center" }}>
							Launch compelling portals from drone and field data in days, not
							months—no tech overhead.
						</Typography>
					</Stack>
				</Container>
				<Container maxWidth="lg">
					<Grid
						alignItems="center"
						container
						spacing={3}>
						<Grid
							size={{
								md: 5,
								xs: 12,
							}}>
							<Stack spacing={2}>
								<div>
									<Chip
										color="success"
										icon={<PiggyBank />}
										label="Save"
										variant="soft"
									/>
								</div>
								<Typography
									color="text.primary"
									variant="h3">
									Attract Quality Prospects
								</Typography>
								<Typography color="text.secondary">
									Give an engaging, professional presentation of a territory and
									its demographics to prospective franchisees.
								</Typography>
							</Stack>
						</Grid>
						<Grid
							size={{
								md: 7,
								xs: 12,
							}}>
							<Box
								sx={{
									margin: "0 auto",
									maxWidth: "100%",
									position: "relative",
									width: "390px",
								}}>
								<Box
									alt="Widgets"
									component="img"
									src="https://placehold.co/390"
									sx={{
										height: "auto",
										position: "relative",
										width: "100%",
										zIndex: 1,
										borderRadius: "20px",
									}}
								/>
							</Box>
						</Grid>
					</Grid>

					<Grid
						alignItems="center"
						container
						spacing={3}>
						<Grid
							size={{
								md: 7,
								xs: 12,
							}}>
							<Box
								sx={{
									margin: "0 auto",
									maxWidth: "100%",
									position: "relative",
									width: "390px",
								}}>
								<Box
									alt="Widgets"
									component="img"
									src="https://placehold.co/390"
									sx={{
										height: "auto",
										position: "relative",
										width: "100%",
										zIndex: 1,
										borderRadius: "20px",
									}}
								/>
							</Box>
						</Grid>
						<Grid
							size={{
								md: 5,
								xs: 12,
							}}>
							<Stack spacing={2}>
								<div>
									<Chip
										color="success"
										icon={<Lightning />}
										label="Speed"
										variant="soft"
									/>
								</div>
								<Typography
									color="text.primary"
									variant="h3">
									Offer Investors Confidence
								</Typography>
								<Typography color="text.secondary">
									Franchisors can invest knowing they will have a viable
									business with enough customers in their territory.
								</Typography>
							</Stack>
						</Grid>
					</Grid>

					<Grid
						alignItems="center"
						container
						spacing={3}>
						<Grid
							size={{
								md: 5,
								xs: 12,
							}}>
							<Stack spacing={2}>
								<div>
									<Chip
										color="success"
										icon={<ArrowsClockwise />}
										label="Sync"
										variant="soft"
									/>
								</div>
								<Typography
									color="text.primary"
									variant="h3">
									Shorten Sales Cycles
								</Typography>
								<Typography color="text.secondary">
									Empowered by data in one engaging platform, prospects make
									quicker decisions leading to significantly shorter sales
									cycles.
								</Typography>
							</Stack>
						</Grid>
						<Grid
							size={{
								md: 7,
								xs: 12,
							}}>
							<Box
								sx={{
									margin: "0 auto",
									maxWidth: "100%",
									position: "relative",
									width: "390px",
								}}>
								<Box
									alt="Widgets"
									component="img"
									src="https://placehold.co/390"
									sx={{
										height: "auto",
										position: "relative",
										width: "100%",
										zIndex: 1,
										borderRadius: "20px",
									}}
								/>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Stack>
		</Box>
	);
}
